module.exports = __webpack_public_path__ + "./img/save.70acf17b55c667e47f183dd750baccbf.png";